import React, { FC } from 'react';
import { Svgs } from '../../../constants/images';
//styles
import {
  Container,
  Row,
  Section,
  Title,
  Value
} from '../cardAndroidDetails.styles';
import { StoreCardDetailsProps } from './storeCardDetails.types';

const StoreCardDetails: FC<StoreCardDetailsProps> = (props) => {
  //props
  const {
    holderName,
    holderId,
    kind,
    address,
    endDateTitle,
    endDate,
    startDateTitle,
    startDate,
    offers,
    phoneNumbers,
    websites,
    disableNotifications,
    addressTitle,
    holderIdTitle,
    holderNameTitle,
    kindTitle,
    offersTitle,
    scheduleTitle,
    emails,
    schedule,
    additionalFields
  } = props;
  //render
  return (
    <Container>
      <Section>
        <Title>{holderNameTitle ? holderNameTitle : 'ticket holder'}</Title>
        <Value>{holderName}</Value>
      </Section>
      <Section>
        <Title>{holderIdTitle ? holderIdTitle : 'Member ID'}</Title>
        <Value>{holderId}</Value>
      </Section>
      {startDate && (
        <Section>
          <Title>{startDateTitle ? startDateTitle : 'Date'}</Title>
          <Value>{startDate}</Value>
        </Section>
      )}
      <Section>
        <Title> {addressTitle ? addressTitle : 'address'}</Title>
        <Value>{address}</Value>
      </Section>
      {kind && (
        <Section>
          <Title>{kindTitle ? kindTitle : 'type'}</Title>
          <Value>{kind}</Value>
        </Section>
      )}
      {additionalFields?.map((el, i) => (
        <Section key={i}>
          <Title>{el.title ? el.title : 'title'}</Title>
          <Value>{el.value}</Value>
        </Section>
      ))}
      <Section>
        <Title> {scheduleTitle ? scheduleTitle : 'schedule'}</Title>
        <Row>
          <Value style={{ whiteSpace: 'pre-line' }}>{schedule}</Value>
        </Row>
      </Section>
      <Section>
        <Title> {offersTitle ? offersTitle : 'offers'}</Title>
        <Value>{offers}</Value>
      </Section>
      {endDate && (
        <Section>
          <Title> {endDateTitle ? endDateTitle : 'Experiation date'}</Title>
          <Row>{<Value>{endDate}</Value>}</Row>
        </Section>
      )}
      {phoneNumbers?.map((el, i) => (
        <Section
          flexDirection='row'
          alignItems='center'
          gap='12px'
          key={i}
          style={{ flexWrap: 'wrap' }}
        >
          <Svgs.PhoneIcon height='16px' width='16px' />
          <Title>{el.title ? el.title : 'Commercial phone'}</Title>
          <Value>{el.value}</Value>
        </Section>
      ))}
      {emails?.map((el, i) => (
        <Section flexDirection='row' alignItems='center' gap='12px' key={i}>
          <Svgs.EmailIcon height='16px' width='16px' />
          <Title>{el.title}</Title>
        </Section>
      ))}
      {websites?.map((el, i) => (
        <Section flexDirection='row' alignItems='center' gap='12px' key={i}>
          <Svgs.GlobeIcon height='16px' width='16px' />
          <Title>{el.title}</Title>
        </Section>
      ))}
      {disableNotifications && (
        <Section flexDirection='row' alignItems='center' gap='12px'>
          <Svgs.GlobeIcon height='16px' width='16px' />
          <Value>{disableNotifications}</Value>
        </Section>
      )}
    </Container>
  );
};

export default StoreCardDetails;
